import React from 'react';
import Header from './Header'
import SideNav from './SideNav';
import Footer from './Footer';
import Home from './Home';
import Contenido from './Contenido';

const Page = (props) => {
    return (
        <>
            <Header></Header>
            <SideNav></SideNav>
            <Contenido datos={props.datos.titulo}>
                {props.children}
            </Contenido>
            <Footer />
        </>
    );
}

export default Page;